import PropTypes from "prop-types";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const TaskTotalsRow = ({ total, completedTotal, onTimeTotal, lateTotal }) => (
  <TR>
    <TD>
      <strong>Totals</strong>
    </TD>
    <TD>
      <strong>{total}</strong>
    </TD>
    <TD>
      <strong>{completedTotal}</strong>
    </TD>
    <TD>
      <strong>{onTimeTotal}</strong>
    </TD>
    <TD>
      <strong>{lateTotal}</strong>
    </TD>
    <TD />
  </TR>
);

TaskTotalsRow.propTypes = {
  total: PropTypes.number.isRequired,
  completedTotal: PropTypes.number.isRequired,
  onTimeTotal: PropTypes.number.isRequired,
  lateTotal: PropTypes.number.isRequired,
};

export default TaskTotalsRow;
